/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions,no-unsafe-optional-chaining,react/prop-types */
import React, { Component, Fragment } from 'react';
import PropTypes, {
  string,
  func,
  arrayOf,
  shape,
  number,
  bool,
} from 'prop-types';
import qs from 'query-string';
import Loadable from 'react-loadable';
import TravelInsuranceFunnel from 'components/funnel/TravelInsuranceFunnel';
import memoize from 'fast-memoize';
import _ from 'lodash';
import debounce from 'lodash.debounce';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import { disableBodyScrolling, setApplicationFormRetryUrl } from 'helpers/Utils';
import Queries from 'queries';
import {
  Card,
  Input,
  LoadingIndicator,
  Freeze,
} from 'components/common';
import FaqContextualContainer, { questionWithArrow } from 'components/FAQ/FaqContextualContainer';
import { withTracking } from 'components/tracking';
import withApplicationConfig from 'containers/withApplicationConfig';
import CompareOtherProductsPanel from 'pages/Verticals/ProductPage/CompareOtherProductsPanel';
import ShortDisclaimer from 'components/TravelInsurance/disclaimers/ShortDisclaimer';
import LongDisclaimer from 'components/TravelInsurance/disclaimers/LongDisclaimer';
import ProviderHeader, { staticTextKeys as providerHeaderStaticTextKeys } from 'components/Provider/ProviderHeader/ProviderHeader';
import ErrorPage from 'pages/ErrorPage';
import BlogPanel from 'components/blog/BlogPanel';
import ResultsListView, { staticTextKeys as resultsListViewStaticTextKeys } from 'pages/Verticals/ResultsPage/ResultsListView';
import { LongFormContent, ImageAndLinkBanner, FaqPanel } from '@hyphengroup/cag-components';
import withUserAgent from 'containers/withUserAgent';
import SeoHead from 'components/seo/SeoHead';
import ResultsPageVideoPanel from './ResultPageVideoPanel';
import GlossaryPanel from './GlossaryPanel';

import {
  getObjectFromArray,
  calculateLoanAmount,
  getFilterWithQueryParam,
  getSortByValueFromSortByListIfNeeded,
  getDefaultFilterValues,
  getAllFiltersExcept,
  getFiltersDisplayByConfig,
  getProviderOptionsFromFilter,
} from './ResultsPageUtils';
import {
  onApplyTrack,
  onResultListUpdateTrack,
  onSortByChangeTrack,
  onResultPageLoadTrack,
  onFiltersChangeTrack,
  locationChangeTrack,
  trackPromotionalBannerClick,
} from './ResultsPageTrackingUtils';
import FiltersRefinePanel from './Filters/FiltersRefinePanel';
import ResultsPageBanner, { staticTextKeys as resultsPageBannerStaticTextKeys } from './ResultsPageBanner';

import './ResultsPage.scss';
import SeoTable from '../../../components/seo/SeoTable';

const MortgageFunnel = Loadable({
  loader: () => import('components/funnel/MortgageFunnel' /* webpackChunkName: "mortgage-funnel" */),
  loading: () => null,
});

export const staticTextKeys = [
  'filterTitleLabel',
  'resetButtonLabel',
  'sortByLabel',
  'faqCTALabel',
  'CC_PRODUCT_PAGE_OFFERS_OPTION_LABEL',
  'CC_PRODUCT_PAGE_COMPARE_TITLE',
  'CC_PRODUCT_PAGE_COMPARE_SUB_TITLE',
  'CC_PRODUCT_PAGE_COMPARE_COMPARE_LABEL',
  'PL_PRODUCT_PAGE_COMPARE_TITLE',
  'PL_PRODUCT_PAGE_COMPARE_SUB_TITLE',
  'PL_PRODUCT_PAGE_COMPARE_COMPARE_LABEL',
  ...resultsPageBannerStaticTextKeys,
  ...resultsListViewStaticTextKeys,
  ...providerHeaderStaticTextKeys,
  'resultsPageHeaderSeeMore',
];

class ResultsPage extends Component {
  static propTypes = {
    language: string,
    displayLanguage: string,
    list: string,
    displayHeading: string,
    subHeadingTitle: string,
    subHeading: string,
    subQuery: string.isRequired,
    imageDimensions: shape({}).isRequired,
    sortByList: arrayOf(shape({})),
    staticPageText: shape({}),
    filterPanel: shape({}),
    faqs: shape({}),
    video: shape({}),
    latestNews: shape({}),
    history: shape({
      push: func.isRequired,
    }).isRequired,
    numberMoreResults: number,
    numberInitialResults: number,
    verticalName: string,
    glossary: shape({}),
    disclaimer: shape({}),
    seoTable: shape({}),
    vertical: string,
    enum: string,
    products: arrayOf(shape({})),
    location: shape({}),
    sortBy: arrayOf(shape({})),
    allCountries: arrayOf(shape({})),
    defaultList: string,
    disclaimerMessages: shape({}),
    resultsPageRouteWithList: string,
    cookies: shape({}),
    provider: shape({}),
    tiRoutes: shape({}),
    mortgageRoutes: shape({}),
    relatedLists: arrayOf(shape({})),
    filterControl: shape({}),
    mappings: shape({}),
    apolloClient: shape({}),
    initialFilterValues: shape({}),
    initialFunnelQuery: shape({}),
    longFormContent: shape({
      sectionImage: shape({}),
      description: shape({}),
    }),
    isEditingFunnel: bool,
    tiLongDisclaimer: string,
    tiShortDisclaimer: string,
    promotionalBanners: arrayOf(shape({})),
    isLearnMore: bool,
    providerImages: arrayOf(shape({})),
    resultsPages: shape({}),
    topBanner: shape({}),
    track: func.isRequired,
    userAgent: PropTypes.shape({
      isMobile: PropTypes.bool,
    }),
  };

  static defaultProps = {
    language: null,
    displayLanguage: null,
    latestNews: null,
    list: null,
    displayHeading: null,
    subHeadingTitle: null,
    subHeading: null,
    filterPanel: {},
    video: null,
    longFormContent: null,
    sortByList: [],
    staticPageText: {},
    faqs: {},
    products: [],
    numberMoreResults: 99,
    numberInitialResults: 99,
    verticalName: null,
    vertical: null,
    enum: null,
    glossary: null,
    disclaimer: null,
    seoTable: null,
    location: {},
    sortBy: [],
    allCountries: [],
    defaultList: null,
    disclaimerMessages: {},
    resultsPageRouteWithList: null,
    cookies: {},
    provider: null,
    tiRoutes: {},
    mortgageRoutes: {},
    relatedLists: null,
    filterControl: {},
    mappings: {},
    apolloClient: {},
    initialFilterValues: null,
    initialFunnelQuery: null,
    isEditingFunnel: false,
    promotionalBanners: [],
    providerImages: [],
    resultsPages: {},
    topBanner: {},
  };

  // Memoized pure functions
  memoizedGetObjectFromArray = memoize(getObjectFromArray, {
    strategy: memoize.strategies.variadic,
  });

  memoizedGetAllFiltersExcept = memoize(getAllFiltersExcept, {
    strategy: memoize.strategies.variadic,
  });

  memoizedGetFilterWithQueryParam = memoize(getFilterWithQueryParam);

  memoizedGetSortByValueFromSortByListIfNeeded = memoize(getSortByValueFromSortByListIfNeeded);

  constructor(props) {
    super(props);
    const {
      products,
      sortBy,
      faqs,
      glossary,
      seoTable,
      numberMoreResults,
      numberInitialResults,
      filterPanel,
      video,
      latestNews,
      longFormContent,
      allCountries,
      defaultList,
      initialFilterValues,
      initialFunnelQuery,
      displayHeading,
      subHeadingTitle,
      subHeading,
      recommendationButton,
    } = props;

    // defaultList seems to be a local fallback list
    const defaultFilterValues = getDefaultFilterValues(
      filterPanel.filterBy,
      defaultList
    );

    this.state = {
      loading: false,
      error: null,
      products,
      sortBy,
      faqs,
      glossary,
      seoTable,
      numberMoreResults,
      numberInitialResults,
      filterPanel,
      video,
      latestNews,
      longFormContent,
      allCountries,
      defaultFilterValues,
      filterValues: {
        ...defaultFilterValues,
        ...initialFilterValues,
        ...initialFunnelQuery,
      },
      sortByValue: null,
      isMobileFilterPanelShow: false,
      funnelQuery: initialFunnelQuery,
      isEditingFunnel: false,
      isVirtalPageLoad: false,
      listViewKey: Date.now(),
      displayList: null,
      displayHeading,
      subHeadingTitle,
      subHeading,
      subQuerySeoMetaData: null,
      recommendationButton,
    };

    this.filtersRefinePanelRef = React.createRef();
    this.onListChange = this.onListChange.bind(this);
    this.onFiltersChange = this.onFiltersChange.bind(this);
    this.onSortByChange = this.onSortByChange.bind(this);
    this.toggleMobileFilterPanel = this.toggleMobileFilterPanel.bind(this);
    this.onBannerEditButtonClick = this.onBannerEditButtonClick.bind(this);
    this.onProductPanelApplyButtonClick = this.onProductPanelApplyButtonClick.bind(this);
    this.onLearnMoreButtonClick = this.onLearnMoreButtonClick.bind(this);
    this.onResetButtonClick = this.onResetButtonClick.bind(this);
    this.onFunnelQuerySubmit = this.onFunnelQuerySubmit.bind(this);
    this.fetchSubQuery = this.fetchSubQuery.bind(this);
    this.debounceFetchSubQuery = debounce(
      this.fetchSubQuery,
      500
    );
    this.onBrowserBackOrForwardButtonClick = this.onBrowserBackOrForwardButtonClick.bind(this);
    this.updateHeading = this.updateHeading.bind(this);
    this.updateFilterSearchParams = this.updateFilterSearchParams.bind(this);
    this.clearFilterSearchParams = this.clearFilterSearchParams.bind(this);
    this.onPromotionalBannerClick = this.onPromotionalBannerClick.bind(this);
  }

  static getDerivedStateFromProps(nextProps) {
    const {
      list,
      enum: verticalEnum,
      mortgageRoutes,
    } = nextProps;
    if (verticalEnum === 'HL') return { displayList: mortgageRoutes[list] };
    return { displayList: list?.toLowerCase() };
  }

  componentDidMount() {
    this.updateHeading();
    /* Tracking */
    onResultPageLoadTrack(this.props, this.state);
  }

  componentDidUpdate({ list: prevList }) {
    /* Tracking */
    locationChangeTrack(this.props, this.state);

    // Capture browser back or forward button click
    const { history } = this.props;
    if (history.action === 'POP') {
      this.onBrowserBackOrForwardButtonClick(prevList);
    }
  }

  componentWillUnmount() {
    // unsubscribe any pending request
    if (this.subQueryObservable) this.subQueryObservable.unsubscribe();
  }

  onBannerEditButtonClick() {
    const { history, location } = this.props;
    const { search, pathname } = location;
    const searchParams = qs.parse(search);
    searchParams.isEditingFunnel = true;
    history.push({
      pathname,
      search: qs.stringify(searchParams),
    });
  }

  /* Tracking */
  onProductPanelApplyButtonClick(e, productId, products) {
    const { location } = this.props;

    // Store url for application form try again url
    setApplicationFormRetryUrl(`${location.pathname}${location.search}`);

    onApplyTrack(this.props, this.state, e, {
      intent: 'apply',
      productId,
      products,
    });
  }

  // For A/B test RA-3310 Tracking
  onLearnMoreButtonClick(e, productId, products, color) {
    onApplyTrack(this.props, this.state, e, {
      intent: `learn more ${color}`,
      productId,
      products,
    }, true);
  }

  onBrowserBackOrForwardButtonClick(prevList) {
    const {
      list,
      enum: verticalEnum,
      mortgageRoutes,
    } = this.props;

    const hasListChanged = prevList !== list;
    if (hasListChanged) {
      // Display list to functional list
      const functionalList = verticalEnum === 'HL' ? mortgageRoutes[list] : list;
      // Change list without pushing to history
      this.onListChange({ value: functionalList }, false);
    }
  }

  onResetButtonClick() {
    const {
      defaultFilterValues,
      funnelQuery,
      filterValues: prevFilterValues,
    } = this.state;

    // Do not do anything if no change
    if (_.isEqual(prevFilterValues, { ...defaultFilterValues, ...funnelQuery })) return;

    this.setState({
      filterValues: {
        ...prevFilterValues,
        ...defaultFilterValues,
        ...funnelQuery,
      },
    }, async () => {
      // Cancel any debounced fetch
      this.debounceFetchSubQuery.cancel();
      await this.fetchSubQuery({});
      this.filtersRefinePanelRef.current?.resetFilters();
    });

    this.clearFilterSearchParams();
  }

  updateHeading() {
    const {
      location,
      provider,
      mappings,
      displayLanguage,
      staticPageText: { staticText: staticTextArray },
    } = this.props;
    const {
      displayHeading,

    } = this.state;

    let heading = null;
    const verticalKey = (provider?.products || [])
      .find(({ vertical: productVertical }) => location.pathname.includes(
        mappings[productVertical]?.route
      ))?.vertical;
    if (!verticalKey) {
      heading = provider?.providerName;
    } else {
      const mapping = getObjectFromArray(staticTextArray);
      heading = `${provider?.providerName}${displayLanguage === 'en' ? ' ' : ''}${mapping?.[verticalKey]}`;
    }
    this.setState({
      displayHeading: heading || displayHeading,
    });

  }

  onListChange(filter, pushToHistory = true) {
    const {
      provider,
      vertical,
      enum: verticalEnum,
      displayLanguage,
      history,
      resultsPageRouteWithList,
      mortgageRoutes,
    } = this.props;

    const {
      filterValues: prevFilterValues,
      funnelQuery,
    } = this.state;
    if (filter.value === prevFilterValues.list) return;

    if (funnelQuery && verticalEnum === 'HL') {
      funnelQuery.mortgageType = filter.value;
    }

    // handle mortgage list showing differently from other verticals
    const displayList = verticalEnum === 'HL'
      ? mortgageRoutes[filter.value]
      : filter.value;

    // Do not push list into route when provider
    if (pushToHistory && !provider) {
      history.push({
        pathname: _.template(resultsPageRouteWithList)({
          language: displayLanguage,
          vertical,
          list: displayList,
        }),
        search: qs.stringify({
          ...funnelQuery && {
            isEditingFunnel: false,
            funnelQuery: JSON.stringify(funnelQuery),
          },
        }),
      });
    } else {
      this.clearFilterSearchParams();
    }

    this.setState({
      sortByValue: null,
      filterValues: {
        ...funnelQuery,
        list: filter.value,
      },
      displayList,
      isVirtalPageLoad: false,
    }, async () => {
      // Cancel any debounced fetch
      this.debounceFetchSubQuery.cancel();
      await this.fetchSubQuery({
        isResetToNewDefaults: true,
      });
      this.filtersRefinePanelRef.current?.resetFilters();
      this.updateHeading();
    });
  }

  onSortByChange(option = {}) {
    const sortBy = {
      name: option.value,
      value: option.label,
    };

    this.setState({
      listViewKey: Date.now(),
      sortByValue: sortBy.name,
      isVirtalPageLoad: false,
    });

    /* Tracking */
    onSortByChangeTrack(this.props, this.state, sortBy);
  }

  onFiltersChange(filter) {
    const {
      provider,
      enum: verticalEnum,
    } = this.props;
    const {
      queryParam,
      value: newValue,
      minValue = -Infinity,
      maxValue = Infinity,
    } = filter;
    const { filterValues, funnelQuery } = this.state;

    // Validate functions
    const isUnchanged = v => v === filterValues[queryParam];
    const isInvalidValue = v => v === undefined || v === null || v === '' || Number.isNaN(v);
    const isOutOfRange = v => Number.isInteger(v)
      && (v < minValue || v > maxValue);

    if (isUnchanged(newValue)) return;

    // Calclate mortgage loan amount
    let loanAmount = null;
    if (verticalEnum === 'HL') {
      const newPropertyValue = queryParam === 'propertyValue'
        ? newValue
        : filterValues.propertyValue;
      const newBorrowPercentage = queryParam === 'borrowPercentage'
        ? newValue
        : filterValues.borrowPercentage;
      loanAmount = calculateLoanAmount(newPropertyValue, newBorrowPercentage);
    }

    const changedFilterValues = {
      ...filterValues,
      [queryParam]: isInvalidValue(newValue) ? undefined : newValue,
      ...(loanAmount && { loanAmount }),
    };

    const isFunnelQueryFilter = Object.keys(funnelQuery || {}).includes(queryParam);

    this.setState({
      filterValues: {
        ...changedFilterValues,
      },
      ...funnelQuery && {
        funnelQuery: {
          ...funnelQuery,
          ...isFunnelQueryFilter && {
            [queryParam]: isInvalidValue(newValue) ? undefined : newValue,
          },
          ...(loanAmount && { loanAmount }),
        },
      },
      isVirtalPageLoad: false,
    }, () => {
      if (isInvalidValue(newValue) || isOutOfRange(newValue)) {
        this.debounceFetchSubQuery.cancel();
        return;
      }

      if (!provider) {
        const { funnelQuery: newFunnelQuery } = this.state;
        this.updateFilterSearchParams(filter, newFunnelQuery);
      }

      this.debounceFetchSubQuery(false, true);
    });

    /* Tracking */
    onFiltersChangeTrack(this.props, filter);
  }

  onFunnelQuerySubmit(funnelQuery) {
    const { history, location } = this.props;
    const { filterValues, defaultFilterValues } = this.state;
    const funnelQueryJsonString = JSON.stringify(funnelQuery);
    this.setState({
      isVirtalPageLoad: true,
    });
    // Push funnel with submitted data
    history.replace({
      pathname: location.pathname,
      search: qs.stringify({
        isEditingFunnel: true,
        funnelQuery: funnelQueryJsonString,
      }),
    });

    // Push results page with submitted data
    history.push({
      pathname: location.pathname,
      search: qs.stringify({
        isEditingFunnel: false,
        funnelQuery: funnelQueryJsonString,
      }),
    });

    // Because only search params change
    // scroll to top won't be triggered automatically
    window.scrollTo(0, 0);

    this.setState({
      filterValues: {
        ...filterValues,
        ...defaultFilterValues,
        ...funnelQuery,
      },
      funnelQuery,
    }, async () => {
      await this.fetchSubQuery({ isResetToNewDefaults: true });
      this.filtersRefinePanelRef.current?.resetFilters();
    });
  }

  async fetchSubQuery({
    isResetToNewDefaults = false,
  }) {
    const {
      apolloClient,
      subQuery,
      language,
      provider,
      defaultList,
      topBanner,
      list,
    } = this.props;

    const {
      filterValues,
      funnelQuery,
      displayHeading,
    } = this.state;

    // unsubscribe any pending request
    if (this.subQueryObservable) this.subQueryObservable.unsubscribe();

    // Set loading state
    this.setState({ loading: true });

    const query = Queries[subQuery];
    const variables = {
      ...filterValues,
      ...provider && { providers: [provider.alias] },
      language,
      timestamp: Date.now(),
    };

    const { mobileImageKey, desktopImageKey } = topBanner || {};
    if (mobileImageKey && desktopImageKey) {
      variables.promotionalBanners = [mobileImageKey, desktopImageKey];
    }

    // Manually trigger graphql query
    try {
      const { data } = await new Promise((resolve, reject) => {
        this.subQueryObservable = apolloClient.watchQuery({ query, variables })
          .subscribe(resolve, reject);
      });
      if (data?.seoMetadata && list) {
        this.setState({
          subQuerySeoMetaData: data?.seoMetadata,
        });
      }
      // defaultList seems to be a local fallback list
      const newDefaultFilterValues = getDefaultFilterValues(
        data?.resultsPage?.filterPanel?.filterBy,
        defaultList,
      );

      await new Promise((resolve) => {
        this.setState({
          loading: false,
          ...data?.resultsPage,
          displayHeading: isResetToNewDefaults ? data?.resultsPage?.displayHeading : displayHeading,
          listViewKey: Date.now(),
          // Update default filter values
          defaultFilterValues: newDefaultFilterValues,
          ...isResetToNewDefaults && {
            filterValues: {
              ...filterValues,
              ...newDefaultFilterValues,
              ...funnelQuery,
            },
          },
          // for SG TI
          allCountries: data?.allCountries || [],
        }, resolve);
      });

      /* Tracking */
      onResultListUpdateTrack(this.props, this.state);
    } catch (error) {
      this.setState({
        loading: false,
        error,
      });
    }
  }

  toggleMobileFilterPanel() {
    this.setState(({ isMobileFilterPanelShow }) => ({
      isMobileFilterPanelShow: !isMobileFilterPanelShow,
    }), () => {
      const { isMobileFilterPanelShow } = this.state;
      disableBodyScrolling(isMobileFilterPanelShow);
    });
  }

  updateFilterSearchParams(filter, funnelQuery) {
    const { queryParam, value } = filter;
    const { history, location } = this.props;
    const searchParams = qs.parse(location.search);
    if (funnelQuery) searchParams.funnelQuery = JSON.stringify(funnelQuery);
    if (!funnelQuery || !funnelQuery[queryParam]) searchParams[queryParam] = value;
    history.replace({
      pathname: location.pathname,
      search: qs.stringify(searchParams),
    });
  }

  clearFilterSearchParams() {
    const { history, location } = this.props;
    const searchParams = qs.parse(location.search);
    const { isEditingFunnel, funnelQuery } = searchParams;
    history.replace({
      pathname: location.pathname,
      search: qs.stringify({
        ...isEditingFunnel && { isEditingFunnel },
        ...funnelQuery && { funnelQuery },
      }),
    });
  }

  onPromotionalBannerClick() {
    const {
      userAgent,
      track,
      resultsPages,
      vertical,
      promotionalBanners,
    } = this.props;
    const key = userAgent?.isMobile ? 'mobileImageKey' : 'desktopImageKey';
    const imageKey = resultsPages[vertical]?.topBanner?.[key];
    const [image] = promotionalBanners?.filter(banner => banner.title === imageKey);
    trackPromotionalBannerClick(track, { title: image?.image?.title });
  }

  render() {
    const {
      verticalName,
      enum: verticalEnum,
      staticPageText: { staticText: staticTextArray },
      imageDimensions,
      displayLanguage,
      language,
      disclaimerMessages,
      provider,
      vertical,
      relatedLists,
      filterControl,
      mappings,
      isEditingFunnel,
      tiShortDisclaimer,
      tiLongDisclaimer,
      promotionalBanners,
      isLearnMore,
      providerImages,
      resultsPages,
    } = this.props;

    const {
      displayList,
      products,
      sortBy,
      faqs,
      glossary,
      seoTable,
      numberMoreResults,
      numberInitialResults,
      filterPanel,
      video,
      latestNews,
      longFormContent,
      allCountries,
      filterValues,
      defaultFilterValues,
      isMobileFilterPanelShow,
      sortByValue: initialSortByValue,
      funnelQuery,
      listViewKey,
      loading,
      displayHeading,
      subHeadingTitle,
      subHeading,
      subQuerySeoMetaData,
      recommendationButton,
    } = this.state;
    const staticText = this.memoizedGetObjectFromArray(staticTextArray);
    const isListValid = (() => {
      const { tiRoutes, mortgageRoutes } = this.props;
      // Check if the display list is in anywhere in the config
      if (verticalEnum === 'TI') return !displayList || tiRoutes[displayList];
      if (verticalEnum === 'HL') return !displayList || mortgageRoutes[displayList];
      return true;
    })();

    if (!isListValid) {
      return <ErrorPage errorCode={404} />;
    }

    const shouldShowTiFunnel = verticalEnum === 'TI';
    const shouldShowHlFunnel = verticalEnum === 'HL';

    if (shouldShowTiFunnel && (!funnelQuery || isEditingFunnel)) {
      return (
        <div className="results-page" data-selector-vertical={verticalEnum} data-selector-list={displayList || defaultFilterValues.list} data-selector-type="results-page-ti-funnnel">
          <TravelInsuranceFunnel
            initialFunnelQuery={funnelQuery}
            onSubmit={this.onFunnelQuerySubmit}
            promotionalBanners={promotionalBanners}
            providerImages={providerImages}
          />
          {tiShortDisclaimer && (
            <ShortDisclaimer short={tiShortDisclaimer} />
          )}
          {video && (
            <Freeze>
              <ResultsPageVideoPanel video={video} />
            </Freeze>
          )}
          {latestNews && latestNews.blogArticles && latestNews.blogArticles.length && (
            <Freeze>
              <BlogPanel {...latestNews} imageWidth={288} />
            </Freeze>
          )}
          {faqs && faqs.faqs && (
            <Freeze>
              <FaqPanel
                {...faqs}
                desktopImage={faqs.desktopImage && {
                  ...faqs.desktopImage,
                  alt: faqs.desktopImage.filename,
                }}
                mobileImage={faqs.mobileImage && {
                  ...faqs.mobileImage,
                  alt: faqs.mobileImage.filename,
                }}
                defaultCtaLabel={staticText.faqCTALabel}
              />
            </Freeze>
          )}
          {tiLongDisclaimer && (
            <LongDisclaimer long={tiLongDisclaimer} />
          )}
          {glossary && glossary.glossaryCta && (
            <Freeze>
              <GlossaryPanel
                {...glossary}
              />
            </Freeze>
          )}
        </div>
      );
    }

    if (shouldShowHlFunnel && (!funnelQuery || isEditingFunnel)) {
      return (
        <div className="results-page" data-selector-vertical={verticalEnum} data-selector-list={displayList || defaultFilterValues.list} data-selector-type="results-page-hl-funnnel">
          <MortgageFunnel
            initialFunnelQuery={funnelQuery}
            onSubmit={this.onFunnelQuerySubmit}
            displayHeading={displayHeading}
          />
          {video && (
            <Freeze>
              <ResultsPageVideoPanel video={video} />
            </Freeze>
          )}
          {latestNews && latestNews.blogArticles && latestNews.blogArticles.length && (
            <Freeze>
              <BlogPanel {...latestNews} imageWidth={288} />
            </Freeze>
          )}
          {faqs && faqs.faqs && (
            <Freeze>
              <FaqPanel
                {...faqs}
                desktopImage={faqs.desktopImage && {
                  ...faqs.desktopImage,
                  alt: faqs.desktopImage.filename,
                }}
                mobileImage={faqs.mobileImage && {
                  ...faqs.mobileImage,
                  alt: faqs.mobileImage.filename,
                }}
                defaultCtaLabel={staticText.faqCTALabel}
              />
            </Freeze>
          )}

          {glossary && glossary.glossaryCta && (
            <Freeze>
              <GlossaryPanel
                {...glossary}
              />
            </Freeze>
          )}
        </div>
      );
    }

    const { filterBy } = filterPanel;
    const sortByValue = this.memoizedGetSortByValueFromSortByListIfNeeded(
      initialSortByValue, sortBy,
    );
    const filtersByDisplayControl = getFiltersDisplayByConfig(
      filterBy,
      filterControl,
      displayList || defaultFilterValues.list
    );

    const filterPanelFilters = this.memoizedGetAllFiltersExcept(filtersByDisplayControl, ['list', ...(provider ? ['providers'] : [])]);
    const listFilter = this.memoizedGetFilterWithQueryParam(filterBy, 'list');
    const currentMapping = _.findKey(mappings, { route: vertical });
    const currentVerticalProduct = _.find(provider?.products, { vertical: currentMapping });

    return (
      <div className="results-page" data-selector-vertical={verticalEnum} data-selector-list={displayList || defaultFilterValues.list} data-selector-type="results-page">
        {subQuerySeoMetaData && <SeoHead {...subQuerySeoMetaData} />}
        {provider && (() => {
          const providersFilter = this.memoizedGetFilterWithQueryParam(filterBy, 'providers');
          const providerOptions = getProviderOptionsFromFilter(providersFilter);
          return (
            <ProviderHeader
              {...provider}
              providers={providerOptions}
              staticText={staticText}
              resultsPageVertical={vertical}
            />
          );
        })()}
        <div
          data-selector-type="promotional-banner"
          onClick={this.onPromotionalBannerClick}
        >
          <ImageAndLinkBanner
            desktopImageKey={resultsPages[vertical]?.topBanner?.desktopImageKey}
            mobileImageKey={resultsPages[vertical]?.topBanner?.mobileImageKey}
            promotionalBanners={promotionalBanners}
          />
        </div>
        <Freeze
          key={products.length + displayList}
        >
          <ResultsPageBanner
            heading={displayHeading}
            subHeadingTitle={subHeadingTitle}
            subHeading={subHeading}
            verticalName={verticalName}
            staticText={staticText}
            defaultList={defaultFilterValues.list}
            listFilter={listFilter}
            resultsCount={products.length}
            sortByList={sortBy}
            sortByValue={sortByValue}
            list={displayList}
            onSortByChange={this.onSortByChange}
            onListChange={this.onListChange}
            onFilterButtonClick={this.toggleMobileFilterPanel}
            isShowEditButton={shouldShowTiFunnel}
            onEditButtonClick={this.onBannerEditButtonClick}
          />
        </Freeze>
        <div className="results-wrapper">
          <div className="container-wrapper">
            <div className="row-wrapper">
              <div className={classNames({
                'filter-panel-wrapper': true,
                'hidden-on-mobile': !isMobileFilterPanelShow,
              })}
              >
                <Freeze
                  key={displayList}
                >
                  <FiltersRefinePanel
                    ref={this.filtersRefinePanelRef}
                    onMobileCloseButtonClick={this.toggleMobileFilterPanel}
                    onResetButtonClick={this.onResetButtonClick}
                    onFiltersChange={this.onFiltersChange}
                    filters={filterPanelFilters}
                    filterValues={filterValues}
                    title={staticText.filterTitleLabel}
                    resetButtonLabel={staticText.resetButtonLabel}
                  >
                    {sortBy && sortBy.length > 1 && (
                      <Card.Content className="sort-by-card">
                        <Input
                          title={staticText.sortByLabel}
                          as="select"
                          value={sortByValue}
                          onChange={selectedValue => this.onSortByChange(_.find(sortBy
                            .map(({ name: value, value: label }) => ({
                              label,
                              value,
                            })), { value: selectedValue }))}
                          options={sortBy
                            .map(({ name: value, value: label }) => ({
                              label,
                              value,
                            }))}
                        />
                      </Card.Content>
                    )}
                  </FiltersRefinePanel>
                </Freeze>
              </div>
              <div className="results-container">
                {loading
                  ? <LoadingIndicator />
                  : (
                    <ResultsListView
                      key={listViewKey}
                      products={products}
                      onResetFilters={this.onResetButtonClick}
                      onIsShowMoreChange={this.onIsShowMoreChange}
                      sortByValue={sortByValue}
                      numberInitialResults={numberInitialResults}
                      numberMoreResults={numberMoreResults}
                      staticText={staticText}
                      imageDimensions={imageDimensions}
                      onProductPaneCtaLinkClickWithIdAndProducts={this
                        .onProductPanelApplyButtonClick}
                      list={filterValues.list || defaultFilterValues.list}
                      language={displayLanguage}
                      locale={language}
                      disclaimerMessages={disclaimerMessages}
                      verticalEnum={verticalEnum}
                      vertical={vertical}
                      allCountries={allCountries}
                      selectedInsuranceType={funnelQuery?.insuranceType}
                      selectedRegion={funnelQuery?.region}
                      isLearnMore={isLearnMore}
                      onLearnMoreClick={this.onLearnMoreButtonClick}
                      recommendationData={recommendationButton}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>
        {provider && currentVerticalProduct?.faqs && currentVerticalProduct?.faqs?.faqs && (
          <div className="faq-section">
            <div className="faq-container">
              <FaqContextualContainer
                title={currentVerticalProduct.faqs.heading}
                faqs={currentVerticalProduct.faqs}
                questionRender={questionWithArrow}
                viewAllCta={currentVerticalProduct.faqs.viewAllCta}
              />
            </div>
          </div>
        )}
        {provider && (verticalEnum === 'CC' || verticalEnum === 'PL') && relatedLists && relatedLists.length > 0 && (
          <CompareOtherProductsPanel
            categories={relatedLists}
            language={displayLanguage}
            vertical={vertical}
            labels={{
              title:
                staticText[`${verticalEnum}_PRODUCT_PAGE_COMPARE_TITLE`],
              subtitle:
                staticText[`${verticalEnum}_PRODUCT_PAGE_COMPARE_SUB_TITLE`],
              compare:
                staticText[`${verticalEnum}_PRODUCT_PAGE_COMPARE_COMPARE_LABEL`],
            }}
          />
        )}
        {seoTable && <SeoTable {...seoTable} language={displayLanguage} />}
        {!provider && (
          <Fragment>
            {video && (
              <Freeze>
                <ResultsPageVideoPanel video={video} />
              </Freeze>
            )}
            {latestNews && latestNews.blogArticles && latestNews.blogArticles.length && (
              <Freeze>
                <BlogPanel {...latestNews} imageWidth={288} />
              </Freeze>
            )}
            {longFormContent && (
              <Freeze>
                <LongFormContent
                  description={longFormContent?.description}
                  image={longFormContent?.sectionImage}
                />
              </Freeze>
            )}
            {faqs && faqs.faqs && (
              <Freeze>
                <FaqPanel
                  {...faqs}
                  desktopImage={faqs.desktopImage && {
                    ...faqs.desktopImage,
                    alt: faqs.desktopImage.filename,
                  }}
                  mobileImage={faqs.mobileImage && {
                    ...faqs.mobileImage,
                    alt: faqs.mobileImage.filename,
                  }}
                  defaultCtaLabel={staticText.faqCTALabel}
                />
              </Freeze>
            )}
            {glossary && glossary.glossaryCta && (
              <Freeze>
                <GlossaryPanel
                  {...glossary}
                />
              </Freeze>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

export default withUserAgent(withTracking(withRouter(withApplicationConfig(ResultsPage, ['routes', 'ti-funnel', 'mg-funnel', 'verticals']))));
